import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  OnDestroy,
  PLATFORM_ID,
  Inject,
} from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { Observable, Subscription } from 'rxjs'
import { User } from '../../../models/user.model'
import { IProductListing } from '../../../services/market.service'
import { ProductService } from '../../../services/product.service'
import { CartService } from '../../../services/cart.service'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { PaymentService } from '../../../services/payment.service'
import { take } from 'rxjs/operators'
import { SnackbarService } from '../../../services/snackbar.service'
import { AuthenticationService } from '../../../services/authentication.service'
import { IProject } from '../../../models/project.model'
@Component({
  selector: 'app-product-list-item',
  // encapsulation: ViewEncapsulation.ShadowDom,
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
})
export class ProductListItemComponent implements OnInit, OnDestroy {
  Products: Observable<IProductListing[]>

  @Input() product: IProductListing
  @Input() currentUser: User
  @Input() projects: IProject[]
  @Input() buttonClicked: boolean
  @Output() toggleNotification: EventEmitter<any> = new EventEmitter<any>()
  @Output() buttonClickedChange = new EventEmitter<boolean>()

  custom_price: number
  price: number
  discount: number
  discountedPrice: number
  priceText: string
  available: any
  discountedPriceText: string
  userState: boolean

  loggedIn = this.auth.currentUser

  isProjectInputOpen = false
  subscriptions: Subscription

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private productService: ProductService,
    private cart: CartService,
    private router: Router,
    private translate: TranslateService,
    private payment: PaymentService,
    private snackbarService: SnackbarService,
    private auth: AuthenticationService,
    private translateService: TranslateService
  ) {
    this.subscriptions = new Subscription()
    this.subscriptions.add(
      this.translateService.onLangChange.subscribe((newTargetLang) => {
        if (!this.currentUser) {
          this.userState = false
          this.updatePriceText(this.userState)
        } else {
          this.updatePriceText(this.currentUser.isReseller)
        }
      })
    )
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.initProductInfo()
    }
  }

  buttonClickedToggle(isClicked: boolean) {
    this.buttonClicked = isClicked
    this.buttonClickedChange.emit(isClicked)
  }

  updatePriceText(userState) {
    const { priceText, discountedPriceText } =
      this.productService.translatePriceText(userState, this.discount)
    this.priceText = priceText
  }

  initProductInfo() {
    this.subscriptions.add(
      this.productService
        .getPriceInformation(this.product)
        .subscribe((price) => {
          this.price = price.price
          this.discount = price.discount
          this.custom_price = price.customPrice
          this.discountedPrice = price.discountedPrice
          this.priceText = price.priceText
        })
    )
  }

  addToCartDialog(event: MouseEvent) {
    if (this.buttonClicked) {
      return
    }
    this.buttonClickedToggle(true)
    event.stopPropagation()

    this.payment
      .getAvailability(this.product.id)
      .pipe(take(1))
      .subscribe(
        (result) => {
          this.available = result
          this.cart.add({
            available: this.available,
            name: this.product.name,
            id: this.product.id,
            vendor_price: this.product.vendor_price,
            price: this.product.price,
            customPrice: this.product.customPrice,
            quantity: 1,
            discount: this.product.discount,
          })
          setTimeout(() => {
            this.router.navigate([this.translate.currentLang, 'cart'])
            this.buttonClickedToggle(false)
          }, 500)
        },
        (err) => {
          this.buttonClickedToggle(false)
          this.snackbarService.showSnackbar(
            'error.error_retrieving',
            'error.button.close',
            'error-snack'
          )
        }
      )
  }

  createProductNotification(event: MouseEvent) {
    event.stopPropagation()
    this.toggleNotification.emit()
  }

  gotoProduct() {
    return this.productService.gotoProduct(this.product)
  }

  urlName(product: IProductListing) {
    return this.productService.productUrl(product.name, product.vendor)
  }

  openProjectList(event: MouseEvent) {
    event.stopPropagation()
    this.isProjectInputOpen = true
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    event.stopPropagation()
    if (this.isProjectInputOpen) {
      this.isProjectInputOpen = false
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
